/**
 * Priorités proposées à la création, reprises de la combo du V1
 * (support-lib.cgi, sub combo_prio) : 1 à 15, 100, 500, 999, avec les mêmes
 * libellés. L'API refuse toute autre valeur.
 */
export interface PriorityOption {
  value: number;
  label: string;
}

function v1Label(i: number): string {
  if (i === 1) return 'Urgence absolue (piratage, bancaire)';
  if (i === 2) return 'Urgence absolue (perte de données)';
  if (i === 3) return 'Très urgent (serveur down)';
  if (i === 4) return 'Très urgent (Pb bloquant en production)';
  if (i === 5) return 'Très urgent (Pb génant en production)';
  if (i <= 7) return 'A traiter dans la journée';
  if (i <= 10) return 'A traiter dans la semaine';
  return 'A traiter la semaine prochaine';
}

export const V1_PRIORITY_OPTIONS: PriorityOption[] = [
  ...Array.from({ length: 15 }, (_, k) => ({ value: k + 1, label: `${k + 1} - ${v1Label(k + 1)}` })),
  { value: 100, label: '100 - A programmer' },
  { value: 500, label: '500 - Taches non programmables' },
  { value: 999, label: '999 - En cours de saisie' },
];

/**
 * Priorité urgente : 5 ou moins (« Très urgent » et « Urgence absolue » du V1).
 * À ce seuil, la règle du V1 reprise par la V2 (v1compat.ts) ne retire plus
 * Julien (utilisateur 3) des destinataires : le courriel part à tous les
 * traitants du point.
 */
export const URGENT_PRIORITY_MAX = 5;

export const isUrgentPriority = (p: number): boolean => Number.isInteger(p) && p >= 1 && p <= URGENT_PRIORITY_MAX;

/**
 * Faut-il confirmer ? À la création : toute priorité urgente. À la
 * modification : seulement quand le point DEVIENT urgent (il ne l'était pas).
 */
export function needsUrgentConfirm(next: number | undefined, previous?: number): boolean {
  if (next === undefined || !isUrgentPriority(next)) return false;
  return previous === undefined || !isUrgentPriority(previous);
}

/** Texte de la confirmation, clair pour un non-technicien. */
export function urgentConfirmMessage(p: number, when: 'creation' | 'modification'): string {
  const consequence =
    when === 'creation'
      ? 'le courriel de création partira à tous les traitants du point, Julien compris'
      : 'les prochains courriels de ce point partiront à tous ses traitants, Julien compris';
  return (
    `Priorité ${p} : ${v1Label(p)}.\n\n` +
    `C’est une priorité urgente (5 ou moins) : le point passe en tête des listes et ${consequence}.\n\n` +
    (when === 'creation' ? 'Créer ce point en urgence ?' : 'Passer ce point en urgence ?')
  );
}
